import axios from "axios";
import { SecuritySanitizer } from "../../services/SecuritySanitizer";

export const saveCourse = (data, callback) => {
  let method, url;

  // Sanitizar datos antes de enviar
  const sanitizedData = SecuritySanitizer.sanitizeCourseData(data);

  // Validar datos sanitizados
  const validation = SecuritySanitizer.validateData(sanitizedData);
  if (!validation.isValid) {
    callback({
      status: 400,
      data: {
        error: "Error de seguridad detectado",
        details: validation.errors,
        message: validation.errors[0] || "Contenido no permitido"
      }
    });
    return;
  }

  // Ahora siempre esperamos JSON (incluso cuando hay archivos en Base64)
  const courseId = sanitizedData.course?.id;

  if (courseId) {
    method = "patch";
    url = `/api/courses/${courseId}`;
  } else {
    method = "post";
    url = "/api/courses";
  }

  // Configurar headers para JSON
  const headers = {
    "X-CSRF-TOKEN": window.Hupe8.token,
    "Content-Type": "application/json",
    "Accept": "application/json"
  };

  var promise = axios({
    method: method,
    url: url,
    data: sanitizedData,
    headers: headers
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};

export const switchState = (data, callback) => {
  let method, url;
  method = "put";
  url = `/api/publication_bases/${data.publication_id}/switch_state`;
  var promise = axios({
    method: "put",
    url: url,
    data: data,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8.token
    }
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};

export const fetchRecruiters = (callback) => {
  const method = "get";
  const url = "/api/applicants/recruiters";

  const promise = axios({
    method: method,
    url: url,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8.token
    }
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
